import api from './api';
import { Departamento, ApiResponse, UsuarioDoDepartamento } from '../types';

export const departamentoService = {
  listar: async (): Promise<Departamento[]> => {
    const response = await api.get<Departamento[]>('/departamentos');
    return response.data;
  },

  listarAtivos: async (): Promise<Departamento[]> => {
    const response = await api.get<Departamento[]>('/departamentos/ativos');
    return response.data;
  },

  /** Apenas os departamentos aos quais o usuario logado tem acesso. */
  listarAcessiveis: async (): Promise<Departamento[]> => {
    const response = await api.get<Departamento[]>('/departamentos/acessiveis');
    return response.data;
  },

  listarArvore: async (): Promise<Departamento[]> => {
    const response = await api.get<Departamento[]>('/departamentos/arvore');
    return response.data;
  },

  buscarPorId: async (id: number): Promise<Departamento> => {
    const response = await api.get<Departamento>(`/departamentos/${id}`);
    return response.data;
  },

  cadastrar: async (departamento: Departamento): Promise<ApiResponse<Departamento>> => {
    const response = await api.post<ApiResponse<Departamento>>('/departamentos', departamento);
    return response.data;
  },

  atualizar: async (id: number, departamento: Departamento): Promise<ApiResponse<Departamento>> => {
    const response = await api.put<ApiResponse<Departamento>>(`/departamentos/${id}`, departamento);
    return response.data;
  },

  deletar: async (id: number): Promise<ApiResponse<void>> => {
    const response = await api.delete<ApiResponse<void>>(`/departamentos/${id}`);
    return response.data;
  },

  listarUsuarios: async (id: number): Promise<UsuarioDoDepartamento[]> => {
    const response = await api.get<UsuarioDoDepartamento[]>(`/departamentos/${id}/usuarios`);
    return response.data;
  },

  vincularUsuario: async (id: number, usuarioId: number): Promise<ApiResponse<void>> => {
    const response = await api.post<ApiResponse<void>>(`/departamentos/${id}/usuarios/${usuarioId}`);
    return response.data;
  },

  desvincularUsuario: async (id: number, usuarioId: number): Promise<ApiResponse<void>> => {
    const response = await api.delete<ApiResponse<void>>(`/departamentos/${id}/usuarios/${usuarioId}`);
    return response.data;
  },
};